<template>
  <div class>
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" :before-close="handleChangeDrawer" width="400px">
      <div class="pay-mains">
        <el-form
          ref="form"
          :model="form"
          class="demo-ruleForm"
          label-width="80px"
          label-position="left"
        >
          <el-form-item
            ref="rechargeAmount"
            label="充值金额"
            prop="rechargeAmount"
            :rules="$rules.money"
            class="flex-rows"
          >
            <el-input v-model.trim="form.rechargeAmount" placeholder="请输入充值金额" maxlength="8"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="back">取消</el-button>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "新增充值额度",
      addEditShow: false,
      form: {
        mobile: ""
      }
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      //   this.$router.push("/collectMoney");
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    onSubmit(values) {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$api
            .post(this.$url.shopRechargeApply.save, this.form)
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  .flex-rows {
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    margin: 0;
    align-items: center;
    background: #fff;
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>